import { MutationHookOptions, useMutation } from '@apollo/client';

import mutation from './applyDepotResetMutation.graphql';

export const useApplyDepotResetMutation = (
  opts?: MutationHookOptions<
    ApplyDepotResetMutation,
    ApplyDepotResetMutationVariables
  >,
) =>
  useMutation<ApplyDepotResetMutation, ApplyDepotResetMutationVariables>(
    mutation,
    opts,
  );
